<template>
  <v-card
    flat
    class="pa-4 pa-md-14"
    :style="{
      background: value.sectionColor.backGround,
      color: value.sectionColor.text,
    }"
  >
    <v-card-title class="section-title pa-2" style="color: inherit !important">
      {{ value.title }}
    </v-card-title>
    <v-card-subtitle class="ma-0 pa-2" style="color: inherit !important">
      {{ value.description }}
    </v-card-subtitle>

    <v-row no-gutters>
      <v-col cols="12" v-for="(x, i) in value.items" :key="i" class="pa-2">
        <testimonials-card
          :testimonials="x"
          style="background: transparent !important"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import TestimonialsCard from "../cm/testimonialsCard";

export default {
  name: "bTestimonialsView",

  components: { TestimonialsCard },

  props: {
    value: Object,
  },

  beforeCreate() {
    const loadScript = (src) =>
      new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.setAttribute("src", src);
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });

    const gsapScript = () => loadScript("/js/gsap.min.js");
    gsapScript();
  },
};
</script>

<style scoped>
.section-title {
  position: relative;
}

.section-title:before {
  content: "";
  width: 150px;
  height: 1px;
  background: var(--v-primary-base);
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
